import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { paragraphLarge } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.a `
  --contentColour: ${brand.blue.dark};
  --bgColour: ${brand.global.white};

  ${transition('transform, box-shadow', 0.25)};

  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 20px 0;
  color: var(--contentColour);
  background-color: var(--bgColour);
  overflow: hidden;
  box-shadow: 0px 5px 5px -2px rgba(0, 0, 0, 0.2);
  text-decoration: none;

  &[data-has-curve='true'] {
    border-radius: 20px 20px 20px 0;
  }

  &:focus-visible,
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 15px 5px -10px rgba(0, 0, 0, 0.2);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 2px;
    outline-width: 2px;
    outline-style: solid;
    outline-color: ${brand.global.black};
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(271, 279)};

  --imageBgColor: ${brand.blue.gradient};
  --iconColor: ${brand.global.white};

  display: grid;
  place-content: center;
  position: relative;
  background: var(--imageBgColor);

  &[data-bg-color='mortgages'] {
    --imageBgColor: ${brand.green.gradient};
    --direction: 0deg;
  }

  &[data-bg-color='intermediaries'] {
    --imageBgColor: ${brand.green.light};
    --iconColor: ${brand.blue.navy};
  }

  svg {
    width: ${fluid(80, 120)};
    height: ${fluid(80, 120)};
    color: var(--iconColor);
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const ContentWrapper = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${fluid(10, 17)} ${fluid(10, 18)} ${fluid(10, 22)};
`;
const ContentArea = styled.div `
  flex: 1 0 auto;
`;
const Heading = styled.h3 `
  ${paragraphLarge};
  ${fonts.proximaNova.bold};

  margin-bottom: 8px;

  @media ${from(Device.Tablet)} {
    min-height: 1px;
  }
`;
const Description = styled.p `
  ${fonts.proximaNova.regular};
  font-size: ${fluid(14, 16)};
  line-height: ${fluid(22, 26)};
  margin: 0;
`;
const TabbedSignpostCardStyles = {
    Container,
    ContentArea,
    ImageContainer,
    Image,
    ContentWrapper,
    Heading,
    Description,
};
export default TabbedSignpostCardStyles;
